import { css } from "@compiled/react";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation, {
    ReturnToProduct
} from "@/components/signup/site-activation";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    Headings,
    ReturnToProductSubheading,
    ReturnToProductText,
    WelcomeBackHeading,
    WelcomeBackText
} from "../../../components";

export const CurrentProductUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    return (
        <JiraOverlayTemplate size="sm">
            <div css={containerCss}>
                {team26VisualUpdates ? (
                    <Headings
                        main={<WelcomeBackText />}
                        sub={<ReturnToProductText />}
                    />
                ) : (
                    <>
                        <WelcomeBackHeading />
                        <ReturnToProductSubheading />
                    </>
                )}
                <SiteActivation
                    CurrentProductUser={<ReturnToProduct />}
                    useContactExpandCohortLogic={true}
                />
            </div>
        </JiraOverlayTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
